import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../../services/component.service';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'app-asset-setting',
	templateUrl: './asset-setting.component.html',
	styleUrls: ['./asset-setting.component.scss']
})
export class AssetSettingComponent implements OnInit, OnDestroy {
	@ViewChild('assetForm', { static: true }) assetForm: NgForm;
	@Input() assetSetting: any;
	@Input() componentData: any;
	assetFormSubscription: Subscription;

	constructor(private cs: ComponentService) {}

	ngOnInit() {
		this.assetFormSubscription = this.assetForm.valueChanges
			.pipe(tap(() => this.cs.updateDisabledSave(this.assetSetting.token === '' || (this.assetForm.dirty && this.assetForm.invalid))))
			.subscribe((form) => {
				this.componentData.config.mapping_params[this.assetSetting.key].token = form.token;
				this.componentData.config.mapping_params[this.assetSetting.key].name = form.name;
				this.componentData.config.mapping_params[this.assetSetting.key].required = form.required;
				this.componentData.config.mapping_params[this.assetSetting.key].fallback = form.fallback;
			});
	}

	ngOnDestroy(): void {
		this.assetFormSubscription.unsubscribe();
	}
}
